import React, { Children, cloneElement } from 'react'
// libs
import styled from 'styled-components'

const ChildrenWrapper = styled.div`
  height: 100%;
`

const Wrapper = styled.div`
  padding: 5px 0;

  ${({ hasClickHandler }) => hasClickHandler && 'cursor: pointer;'}
`

const TreeNodeRenderer = (props) => {
  const {
    children,
    swapFrom,
    swapLength,
    swapDepth,
    scaffoldBlockPxWidth,
    lowerSiblingCounts,
    connectDropTarget,
    isOver,
    draggedNode,
    canDrop,
    treeIndex,
    treeId,
    listIndex,
    rowDirection,
    getPrevRow, // Delete from otherProps
    node, // Delete from otherProps
    path, // Delete from otherProps
    ...otherProps
  } = props

  // Construct the scaffold representing the structure of the tree
  const scaffoldBlockCount = lowerSiblingCounts.length - 1
  // let dropType
  //
  // if (canDrop && !isOver) {
  //   dropType = 'validDrop'
  // } else {
  //   if (!canDrop && isOver) {
  //     dropType = 'invalidDrop'
  //   }
  // }

  return (
    <Wrapper
      {...otherProps}
      data-testid='tree-node'
      data-entity-id={node.id}
      ref={connectDropTarget}
      onClick={node.onClick}
      hasClickHandler={!!node.onClick}>
      <ChildrenWrapper style={{ paddingLeft: scaffoldBlockPxWidth * scaffoldBlockCount }}>
        {Children.map(children, (child) =>
          cloneElement(child, {
            isOver,
            canDrop,
            draggedNode
          })
        )}
      </ChildrenWrapper>
    </Wrapper>
  )
}

TreeNodeRenderer.defaultProps = {
  swapFrom: null,
  swapDepth: null,
  swapLength: null,
  canDrop: false,
  draggedNode: null,
  rowDirection: 'ltr'
}

// TreeNodeRenderer.propTypes = {
//   treeIndex: number.isRequired,
//   swapFrom: number,
//   swapDepth: number,
//   swapLength: number,
//   scaffoldBlockPxWidth: number.isRequired,
//   lowerSiblingCounts: arrayOf(number).isRequired,
//   treeId: string.isRequired,
//   listIndex: number.isRequired,
//   rowDirection: string,
//   children: node.isRequired,
//
//   // Drop target
//   connectDropTarget: func.isRequired,
//   isOver: bool.isRequired,
//   canDrop: bool,
//   draggedNode: shape({}),
//
//   // used in dndManager
//   getPrevRow: func.isRequired,
//   node: shape({}).isRequired,
//   path: arrayOf(oneOfType([string, number])).isRequired
// }

export default TreeNodeRenderer
